import React from "react";
// this Alert Component build for avoid scroll stuck when body overflow crash with dropdown
const AlertAvoidScrollStuck = ({ message,desc,link, onClose, isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="alert-backdrop">
      <div className="alert-box">
        <p className="alert-box-title">{message}</p>
        <p className="alert-box-desc">{desc}</p>
        <p className="alert-box-link">{link}</p>
        <button onClick={onClose}>Done</button>
      </div>
    </div>
  );
};

export default AlertAvoidScrollStuck;
